// Per-row flash targeting for the timeline (2026-07-20). When a set is logged
// as failed, useTimelineLogger raises a `FlashRow` carrying the failed set's
// row-key PREFIX (`${entryIdx}-${setIdx}-`) plus a bumping key; TimelineList
// asks this pure helper, per row, whether that row should flash and with which
// key. Pulled out of the render loop so it has a home + a test: the first cut
// matched the `set-`-wrapped FeedItem key instead of the bare row key, so the
// flash silently never fired (caught in review). The trailing dash in the
// prefix is load-bearing — it stops set `1-2` from matching row `1-20-…`.
//
// A row key is `${entryIdx}-${setIdx}-${completedAt}` (see timelineRows.ts).
// Match against THAT (`row.key`), never the FeedItem `set-${row.key}` key.

export type FlashRow = { prefix: string; key: number } | null;

/** flashRow.key when `rowKey` is the just-failed row (prefix match), else 0
 *  (useAdvanceFlash treats 0 as "no flash" and skips its effect). */
export const flashKeyForRow = (rowKey: string, flashRow: FlashRow): number =>
  flashRow && rowKey.startsWith(flashRow.prefix) ? flashRow.key : 0;
